module.exports = __webpack_public_path__ + "static/media/WoollenLandA0001.4358d2d0.png";